import { useTranslation } from '../i18n';
import { useNbTheme } from '../hooks/useNbTheme';

interface Testimonial {
  key: string;
  width: '1fr' | '1.2fr' | '0.8fr';
}

const testimonials: Testimonial[] = [
  { key: 'testimonial1', width: '1.2fr' },
  { key: 'testimonial2', width: '0.8fr' },
  { key: 'testimonial3', width: '1fr' },
  { key: 'testimonial4', width: '1.2fr' },
];

export default function SocialProofNB() {
  const { t } = useTranslation();
  const { colors } = useNbTheme();

  return (
    <section
      className="py-12 md:py-20"
      style={{ background: colors.bgPage }}
    >
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="mb-8 md:mb-12">
          <h2
            className="font-nb font-bold mb-3"
            style={{
              color: colors.textPrimary,
              fontSize: 'clamp(1.75rem, 3.5vw, 2.5rem)',
              lineHeight: 1.2,
            }}
          >
            {t('socialProof.title')}
          </h2>
          <p
            className="font-nb max-w-xl"
            style={{
              color: colors.textSecondary,
              fontSize: 'clamp(1rem, 1.5vw, 1.25rem)',
              lineHeight: 1.6,
            }}
          >
            {t('socialProof.subtitle')}
          </p>
        </div>

        {/* Masonry grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((testimonial) => {
            const quote = t(`socialProof.${testimonial.key}.quote`);
            const author = t(`socialProof.${testimonial.key}.author`);
            const role = t(`socialProof.${testimonial.key}.role`);

            return (
              <div key={testimonial.key}>
                <div
                  className="border-3 p-5 md:p-6 h-full relative"
                  style={{
                    background: colors.bgCard,
                    borderColor: colors.textPrimary,
                    borderRadius: '2px',
                  }}
                >
                  {/* Quote mark */}
                  <span
                    className="font-nb text-4xl leading-none block mb-2"
                    style={{ color: colors.textMuted }}
                  >
                    &ldquo;
                  </span>

                  {/* Quote text */}
                  <p
                    className="font-nb text-sm md:text-base leading-relaxed mb-4"
                    style={{ color: colors.textSecondary }}
                  >
                    {quote}
                  </p>

                  {/* Author */}
                  <div
                    className="pt-3"
                    style={{ borderTop: `2px solid ${colors.textPrimary}` }}
                  >
                    <p
                      className="font-nb font-bold text-sm"
                      style={{ color: colors.textPrimary }}
                    >
                      {author}
                    </p>
                    <p
                      className="font-nb text-xs"
                      style={{ color: colors.textMuted }}
                    >
                      {role}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Placeholder note — shown when testimonial content is placeholder */}
        {t('socialProof.placeholder') === 'true' && (
          <div
            className="mt-6 p-3 border-3 text-center"
            style={{
              background: colors.bgCard,
              borderColor: colors.accentPrimary || '#FFD600',
            }}
          >
            <p className="font-nb text-xs" style={{ color: colors.textMuted }}>
              These are placeholder testimonials. Replace with real feedback from your customers once you have them.
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
